import React, { useState, useEffect } from "react";
import millify from "millify";
import { Link } from "react-router-dom";
import { Card, Row, Input, Col } from "antd";

import { useGetCryptosQuery } from "../../services/cryptoAPI";

const Cryptocurrencies = ({ simplified }) => {
    const count = simplified ? 10 : 100;

    const { data: cryptoList, isFetching } = useGetCryptosQuery(count);

    const [cryptos, setCryptos] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const filterData = cryptoList?.data?.coins.filter((coin) =>
            coin.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

        setCryptos(filterData);
    }, [cryptoList, searchTerm]);

    if (isFetching) return "Loading...";
    let value = true;

    return (
        <>
            {!simplified && (
                <div className="search-crypto">
                    <Input
                        type="text"
                        name=""
                        placeholder="Search Cryptocurrency"
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            )}
            <Row gutter={[32, 32]} className="crypto-card-container">
                {cryptos?.map((currency) => (
                    <Col xs={24} sm={12} lg={6} className="crypto-card" key={currency.uuid}>
                        <Link to={`/crypto/${currency.uuid}`}>
                            <Card
                                title={`${currency.rank}. ${currency.name}`}
                                extra={
                                    <img
                                        className="crypto-image"
                                        src={currency.iconUrl}
                                        alt={currency.name}
                                        hoverable={value ? 1 : undefined}
                                    />
                                }
                            >
                                <p>
                                    Price :{" "}
                                    {millify(currency.price, { precision: 3, lowercase: true })}
                                </p>
                                <p>
                                    Market Cap :{" "}
                                    {millify(currency.marketCap, {
                                        precision: 3,
                                        lowercase: true,
                                    })}
                                </p>
                                <p>
                                    Daily Change :{" "}
                                    {millify(currency.change, { precision: 3, lowercase: true })}{" "}
                                    %
                                </p>
                            </Card>
                        </Link>
                    </Col>
                ))}
            </Row>
        </>
    );
};

export default Cryptocurrencies;
